import { useEffect, useState } from "react";
import API, { API_NEW } from "src/API";
import useIsWaiting from "./useIsWaiting";
import useModal from "./useModal";

export type AuthInfoType = {
	avatarUrl: null,
	mortal: false,
	roles: [],
	rules: [],
	userContactId: "",
	userLoggedStatus: false,
	userName: "",
	version: "",
	versionDate: "",
	loading: 'idle'
};

const useAuth = () => {

	const { showError, showWaiting, setWaiting } = useModal();
	const [ authInfo, setAuthInfo ] = useState<AuthInfoType>();
	
	useEffect( () => updateAuthInfo() , [] );

	const updateAuthInfo = () => {
		showWaiting( "Проверка авторизации" );
		API_NEW.onRequest<AuthInfoType>({ url: window.host + '/Nvx.ReDoc.WebInterfaceModule/Controller/DefaultController/ContactInfoBase' })
			.then( res => {
				if ( res.hasError || !res.result ) {
					showError( res.errorMessage, "Ошибка", res.traceparent );
					return;
				}
				setAuthInfo( res.result );
			})
			.finally( () => setWaiting(false) );
	};

	const logoute = () => {
		// удалеине куки номера окна МФЦ
		API.Cookies.deleteCook('mfcWindowNumber', '/');
		API.Cookies.deleteCook('_justLoggedIn', '/');
		localStorage.removeItem('getOrganizationListcurrentUserOrg');
		localStorage.removeItem('currentGetRegisteredPlugins');
		window.location.replace( `${window.host}/WebInterfaceModule/Authentication/Logout?returnUrl=${window.devHost}/new#` );
	};

	return { authInfo, updateAuthInfo, logoute };
};

export default useAuth;
